class TiiOutfitLogic extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    this.tabs = [...this.querySelectorAll('[data-logic-tab]')];
    this.panels = [...this.querySelectorAll('[data-logic-panel]')];
    this.copies = [...this.querySelectorAll('[data-logic-copy]')];
    this.tablist = this.querySelector('.tii-logic__tabs');

    const activateFromTarget = target => {
      const tab = target.closest?.('[data-logic-tab]');
      if (tab && this.contains(tab)) this.activate(tab.dataset.logicTab);
    };

    // Delegated movement makes the first hover work even when the pointer was
    // already inside the tab area while the deferred script finished loading.
    this.tablist?.addEventListener('mousemove', event => activateFromTarget(event.target));
    this.tablist?.addEventListener('pointermove', event => {
      if (event.pointerType !== 'touch') activateFromTarget(event.target);
    });

    this.tabs.forEach((tab, index) => {
      // Rhode-like desktop behaviour: preview the role as soon as the pointer
      // reaches it. Click remains available as the touch/mobile fallback.
      tab.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'touch') this.activate(tab.dataset.logicTab);
      });
      tab.addEventListener('mouseenter', () => this.activate(tab.dataset.logicTab));
      tab.addEventListener('focus', () => this.activate(tab.dataset.logicTab));
      tab.addEventListener('click', () => this.activate(tab.dataset.logicTab));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.activate(this.tabs[next].dataset.logicTab, true);
      });
    });

    document.addEventListener('shopify:block:select', event => {
      const copy = event.target.closest('[data-logic-copy]');
      if (copy && this.contains(copy)) this.activate(copy.dataset.logicCopy);
    });
  }

  activate(value, focus = false) {
    this.tabs.forEach(tab => {
      const active = tab.dataset.logicTab === value;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
      if (active && focus) tab.focus({ preventScroll: true });
    });
    this.panels.forEach(panel => {
      const active = panel.dataset.logicPanel === value;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
    this.copies.forEach(copy => {
      const active = copy.dataset.logicCopy === value;
      copy.hidden = !active;
      copy.classList.toggle('is-active', active);
    });
  }
}

customElements.define('tii-outfit-logic', TiiOutfitLogic);
